export const getters = {
  getActiveOrders(state) {
    return state.activeOrders;
  },
}
